// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"o2-z"};